import { makeStyles } from "@material-ui/core";
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { AcnColorTheme } from "../../assets/css/AcnColorTheme";
import success from "../../assets/img/success.png";
import DynamicTitle from "../../component/DynamicTitle";
import TemplateComponent from "../../component/template/TemplateComponent";
import { Path } from "../../utils/Constant";
import { fontUnit, padGinUnit } from "../../utils/DeviceManager";

interface LocationState {
    from?: string;
}
export function SuccessScreen() {
    const classes = useStyles();
    const location = useLocation<LocationState>();

    useEffect(() => {
        document.title = "สมัครใช้งาน";
    }, [])

    const getTitle = () => {
        if(location.state?.from === Path.account) {
            return 'ลงทะเบียนสำเร็จแล้ว!!';
        }
        return 'จัดการบัญชีสำเร็จ!!';
    }

    const successWidget = () => {
        return (
            <div className={classes.root}>
                <div>
                    <img 
                        src={success} 
                        alt={"success logo"}
                        className={classes.logo}
                    /> 
                    <div className={classes.title}>
                        <DynamicTitle title={getTitle()} size={fontUnit(32)} isFontWeightMediumStyle={false}/>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <TemplateComponent content={successWidget()}
                           noPadding
                           background={AcnColorTheme.primary}
                           showHeadBar={false}
                           footerText="กดปุ่มปิดเพื่อกลับไปหน้าแชทหลัก"
        />
    );
}

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        overflow: "hidden"
    },
    title: {
        paddingLeft: padGinUnit(24), 
        paddingRight: padGinUnit(24), 
        marginTop: padGinUnit(16)
    },
    logo: {
        width: window.innerWidth,
        [theme.breakpoints.up('sm')]: {
            width: window.innerWidth*0.3,
        }
    }
}))